import { Injectable } from "@angular/core";
import { Observable, Observer } from "rxjs";
import { ChatP } from "./pages/chat/chat.model";
import { User } from "./pages/users/user.model";

@Injectable()
export class MessageService {
    private observer: Observer<boolean>;
    private observerStatus: Observer<User>;
    private observerTyping: Observer<ChatP>;
    private observerTyping1: Observer<ChatP>;
    private observerStopTyping: Observer<ChatP>;
    private observerMessage: Observer<ChatP>;
    private observerMessageReceived: Observer<ChatP>;
    onOpenChat: Observable<boolean>;
    onLoadedChats: Observable<boolean>;
    onLoadedMenu: Observable<boolean>;
    onTyping: Observable<ChatP>;
    onTyping1: Observable<ChatP>;
    onStopTyping: Observable<ChatP>;
    onGetMessageReceived: Observable<ChatP>;
    onMessageReceived: Observable<ChatP>;
    onChangeStatus: Observable<User>;

    constructor() {
        this.onOpenChat = new Observable<boolean>(observer =>
            this.observer = observer
        );

        this.onLoadedChats = new Observable<boolean>(observer =>
            this.observer = observer
        );

        this.onLoadedMenu = new Observable<boolean>(observer =>
            this.observer = observer
        );

        this.onTyping = new Observable<ChatP>(observer =>
            this.observerTyping = observer
        );

        this.onTyping1 = new Observable<ChatP>(observer =>
            this.observerTyping1 = observer
        );

        this.onStopTyping = new Observable<ChatP>(observer =>
            this.observerStopTyping = observer
        );

        this.onGetMessageReceived = new Observable<ChatP>(observer =>
            this.observerMessageReceived = observer
        );

        this.onMessageReceived = new Observable<ChatP>(observer =>
            this.observerMessage = observer
        );

        this.onChangeStatus = new Observable<User>(observer =>
            this.observerStatus = observer
        );
    }

    openChat(newStatus: boolean) {
      if (this.observer !== undefined) this.observer.next(newStatus);
    }

    loadedChats(newStatus: boolean) {
        console.log('sending observable loadedChats');
      if (this.observer !== undefined) this.observer.next(newStatus);
    }

    loadedMenu(newStatus: boolean) {
        console.log('sending observable loadedMenu');
      if (this.observer !== undefined) this.observer.next(newStatus);
    }

    sendTyping(newStatus: ChatP) {
        console.log('sending observable sendTyping');
      if (this.observerTyping !== undefined) this.observerTyping.next(newStatus);
    }

    sendTyping1(newStatus: ChatP) {
        console.log('sending observable sendTyping');
      if (this.observerTyping1 !== undefined) this.observerTyping1.next(newStatus);
    }

    sendStopTyping(newStatus: ChatP) {
        console.log('sending observable sendTyping');
      if (this.observerStopTyping !== undefined) this.observerStopTyping.next(newStatus);
    }

    sendMessageReceived(newStatus: ChatP) {
        console.log('sending observable sendTyping');
      if (this.observerMessageReceived !== undefined) this.observerMessageReceived.next(newStatus);
    }

    messageReceived(message: ChatP) {
        console.log('sending observable messageReceived');
      if (this.observerMessage !== undefined) this.observerMessage.next(message);
    }

    changeStatus(user: User) {
        console.log('sending observable changeStatus');
      if (this.observerStatus !== undefined) this.observerStatus.next(user);
    }
}